
<template>
  <v-main>
    <v-overlay style="z-index: 500" :value="!Refreshed">
      <v-container fill-height>
              <v-layout row justify-center align-center>
                <v-progress-circular indeterminate :size="500" :width="7" class="mediumoverline" color="purple">PDF Worker</v-progress-circular>
              </v-layout>
            </v-container>
    </v-overlay>
  <!-- ((FunctionData.FunctionOutput.Width)/2)/DocumentDisplayRatio 
  TotalWidth
  (elmnt.WidthPositionEnd/2)/DocumentDisplayRatio
  :style="elmnt.Justify === 'center' && elmnt.ElementWidth ? 'position:absolute;top:'+(elmnt.PreviewHeightPosition)+'px;left:'+(elmnt.WidthPositionEnd/2)/DocumentDisplayRatio+'px;' : 'position:absolute;top:'+(elmnt.PreviewHeightPosition)+'px;left:'+elmnt.PreviewWidthPosition+'px;'"-->
    <div v-if="$route.name === 'PDFExportFunctionBuilder' && Refreshed || RecordasPDF && Refreshed">
      <span v-for="(elmnt,elmntindex) in ActivePageElements" :key="elmnt.itemObjKey" @click="ActivateActiveElement(elmnt,elmntindex)"
      :style="'position:absolute;top:'+(elmnt.PreviewHeightPosition)+'px;left:'+elmnt.PreviewWidthPosition+'px;'"      
      >
      <span v-html="elmnt.Output">
      </span> 
     <!-- {{elmnt.Output}} -->
      </span>
    </div>
      <v-dialog v-if="!ExportonLoad" v-model="ExportingtoPDFDialog" fullscreen persistent>
          <v-card tile flat>
              <v-card-title>Exporting PDF's
              </v-card-title>
              <v-card-text>
                  <v-select :items="ExporttoPDFFunctions" item-text="FunctionDisplayName" v-model="SelectedFunction" label="Select Export Function" return-object/>
              </v-card-text>
            <v-card-actions>
                <v-btn @click="ToggleDialog('ExportingtoPDFDialog')" icon><v-icon color="red">mdi-close</v-icon></v-btn>
                <v-btn v-if="$route.name !== 'PDFExportFunctionBuilder' && !RecordasPDF" @click="CreateExportTemplate()">Create Export Template</v-btn>
                <v-spacer></v-spacer>
                <v-btn v-if="SelectedFunction" @click="ExporttoPDF(SelectedFunction)">Export</v-btn>
            </v-card-actions>
          </v-card>
      
      </v-dialog>
  </v-main>
</template>

<script>
import firebase from 'firebase';
import db from '@/main'

import format from 'date-fns/format'

import { jsPDF } from "jspdf";

export default {
    props: ['ExporttoPDFFunctions','ExportingtoPDFDialog','FullItem','DocumentDisplayRatio','FunctionPages','ExportingTest','FunctionData'
    ,'ActivePage','PassedFunction','ExportonLoad','PushCompletedFile','RecordasPDF'],
    components: {
     
        jsPDF,
    },
    data(){
        return {
          Refreshed: false,
          //make true testing pruposes of data single export otherwise worker keeps running. need to resolve but too many use cases already need to first dissect
          //in short not working from data single for now
            SelectedFunction: '',
            doc: '',
            FunctionElements: [],
        }
    },
    computed:{
      ActivePageElements(){
            return this.FunctionElements            
            .filter(page => {
                return page.pagenumber === this.ActivePage.PageNumber
            })
            
        },
      FunctionExportPages(){
        let FunctionPages = []
        if(this.FunctionPages){
          FunctionPages = this.FunctionPages
        }
        else{
          //console.log(this.SelectedFunction)
          if(this.SelectedFunction){
            FunctionPages = this.SelectedFunction.Pages
          }          
        }
        // if(FunctionPages.length > 0)
        if(FunctionPages.length > 0){
          //let pdffunction = this.SelectedFunction
          let pagescount = 0
          this.FunctionElements = []
          let FunctionElements = this.FunctionElements
            //console.log(FunctionElements)
            FunctionPages.map(page => {
              let pageobj = Object.assign({},page)
              delete pageobj.Elements
              //let pagenumber = page.PageNumber
              //console.log(this.FullItem,page)
              if(page.PageDatafromArray && page.ArrayType && page.DynamicArrayName){
                let array = []
                if(page.ArrayType === 'SubCollection'){
                 array = this.FullItem.SubCollections.find(obj => obj.id === page.DynamicArrayName).Data
                }
                //console.log(array)
                if(!page.AddPageperArrayItem){
                    pagescount++
                  }
                  //console.log(page)
                  //HeightPositionStart
                  
                  array.map((arritem,arritemindex) => {
                    if(page.AddPageperArrayItem){
                      pagescount++
                    }
                    page.Elements.map(elmnt => {                
                    let elmntobj = Object.assign({},elmnt)
                    elmntobj.fullobj = arritem
                    elmntobj.PageObj = pageobj
                      if(elmnt.ForceNewPage){
                        
                        if(elmnt.OutputType === 'Boolean Response'){
                          if(arritem[elmnt.DataField]){
                            //alert(arritem[elmnt.DataField])
                            if(elmnt.BooleanTrueResponseType === 'Static' && elmnt.BooleanTrueResponse){
                              //alert(elmnt.BooleanTrueResponse)
                              
                              pagescount++
                              elmntobj.pagenumber = pagescount
                              
                              FunctionElements.push(elmntobj)
                            }
                            else if(elmnt.BooleanTrueResponseType === 'Dynamic' && arritem[elmnt.BooleanTrueResponseField]){
                              elmntobj.BooleanTrueResponse = arritem[elmnt.BooleanTrueResponseField]
                              //alert(elmntobj.BooleanTrueResponse)
                              pagescount++
                              elmntobj.pagenumber = pagescount
                              FunctionElements.push(elmntobj)
                            }
                          }
                          else if(!arritem[elmnt.DataField]){
                            if(elmnt.BooleanFalseResponseType === 'Static' && elmnt.BooleanFalseResponse){
                              pagescount++
                              elmntobj.pagenumber = pagescount
                              FunctionElements.push(elmntobj)
                            }
                             else if(elmnt.BooleanFalseResponseType === 'Dynamic' && arritem[elmnt.BooleanFalseResponseField]){
                              elmntobj.BooleanFalseResponse = arritem[elmnt.BooleanFalseResponseField]
                              pagescount++
                              elmntobj.pagenumber = pagescount
                              FunctionElements.push(elmntobj)
                            }                            
                          }
                        }
                        else{
                          pagescount++
                          elmntobj.pagenumber = pagescount
                          FunctionElements.push(elmntobj)
                        }                        
                      }
                      else{
                        if(elmnt.OutputType === 'Boolean Response'){
                          if(arritem[elmnt.DataField] && elmnt.BooleanTrueResponseType === 'Dynamic' && arritem[elmnt.BooleanTrueResponseField]){
                           elmntobj.BooleanTrueResponse = arritem[elmnt.BooleanTrueResponseField]
                          }
                          else if(!arritem[elmnt.DataField] && elmnt.BooleanFalseResponseType === 'Dynamic' && arritem[elmnt.BooleanFalseResponseField]){
                            elmntobj.BooleanFalseResponse = arritem[elmnt.BooleanFalseResponseField]                            
                          }
                        }
                        elmntobj.pagenumber = pagescount
                        FunctionElements.push(elmntobj)
                      }
                      
                    })
                    
                  })
                }
                else{
                  pagescount++
                  page.Elements.map((elmnt,elmntindex) => {
                    if(elmnt.ForceNewPage && elmntindex !== 0){
                      pagescount++
                    }
                    let elmntobj = Object.assign({},elmnt)
                    elmntobj.PageObj = pageobj          
   
                  
                  elmntobj.pagenumber = pagescount
                  FunctionElements.push(elmntobj)
                  })
                  
                }             
            })
            
            let exportpages = []
            FunctionElements.map(elmnt => {
              let pageobj = Object.assign({},elmnt.PageObj)
              pageobj.PageNumber = elmnt.pagenumber
              let oncheck = exportpages.find(obj => obj.PageNumber === pageobj.PageNumber)
              if(!oncheck){
                exportpages.push(pageobj)
              }              
            })
            return exportpages.map(page => {
              page.Elements = FunctionElements.filter(elmnt => {
                
                return elmnt.pagenumber === page.PageNumber
              })
              return page
            })
        }
      },
        userLoggedIn () {
            return this.$store.getters.user
        },
    },
    watch: {
        ExportingTest (value) {
            if (value) {
                //console.log(value,this.doc)
                if(this.doc){
                  this.doc.save(this.FullItem[this.FullItem.RecordPrimaryFieldName]+" - "+this.FunctionData.FunctionDisplayName+".pdf")
                }
            }
        },
        ActivePage: {
            handler: function(oldvalue, newvalue) {
              
              if(oldvalue !== newvalue){
                this.ExporttoPDF(this.SelectedFunction)           
              }
            },
            deep: true
        },
        
    },
    created(){
      if(this.PassedFunction){
        this.SelectedFunction = this.PassedFunction
        if(this.ExportonLoad){
          this.ExporttoPDF(this.SelectedFunction)
        }
      }
      if(this.$route.name === 'PDFExportFunctionBuilder' || this.RecordasPDF){
        this.SelectedFunction = this.FunctionData
        //console.log(this.SelectedFunction,this.ActivePage,this.ActivePageElements,this.FunctionElements)
        this.ExporttoPDF(this.SelectedFunction)
      }
      if(this.$store.state.PDFBuilderActive){
        //this.Refreshed = true
        console.log('this.FullItem',this.FullItem)
      }
            //basically this is the middle component
            //this.GetExporttoPDFFunctions()
    },
    methods:{
      ActivateActiveElement(elmnt,elmntindex){
        this.$emit('ActivateActiveElement',elmnt,elmntindex)
      },
        ToggleDialog(dialogname){
            this.$emit('ToggleDialog',dialogname)
        },
        getDataUrl(img) {
      // Create canvas
      //alert('yay canvas')
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      // Set width and height
      canvas.width = img.width;
      canvas.height = img.height;
      // Draw the image
      canvas.setAttribute('crossOrigin','no-cors')
      ctx.drawImage(img, 0, 0);
      return canvas.toDataURL();
    },
    isHTML(str) {
      var doc = new DOMParser().parseFromString(str, "text/html");
      return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
    },
    PDFLineGenerator(pagenumber,fullobj,page,doc,pageWidth,pageHeight,totalpages,topposition,elmnt,colwidth,colstart){
      let vm = this
      return new Promise(function(resolve, reject) {
      doc.setLineWidth(elmnt.LineThickness)
      doc.setDrawColor(elmnt.LineColor.r,elmnt.LineColor.g,elmnt.LineColor.b)
      //basically widthstart,heightstart,lengthofline,heightend.
      //so unless you want a skew/diagonalline, the heightend is topposition synonomously
      let heightposition = topposition+elmnt.PaddingTop
      let widthposition = colstart+elmnt.PaddingLeft
      //console.log('PDFLineGenerator',widthposition,heightposition,widthposition+elmnt.LineWidth,heightposition)
      doc.line(widthposition,heightposition,widthposition+elmnt.LineWidth,heightposition)
      elmnt.HeightPositionStart = heightposition
      elmnt.HeightPositionEnd = heightposition+elmnt.LineThickness
      elmnt.WidthPositionStart = widthposition
      elmnt.WidthPositionEnd = widthposition+elmnt.LineWidth
      elmnt.PreviewHeightPosition = elmnt.HeightPositionStart*vm.DocumentDisplayRatio
        elmnt.PreviewWidthPosition = elmnt.WidthPositionStart*vm.DocumentDisplayRatio
      elmnt.Output = ''
      resolve(elmnt)
      })
    },
    PDFCanvasGenerator(pagenumber,fullobj,page,doc,pageWidth,pageHeight,totalpages,topposition,elmnt,colwidth,colstart){
      let vm = this
      return new Promise(function(resolve, reject) {
      let widthposition = 0
      let heightposition = topposition+elmnt.PaddingTop
      let canvas = document.createElement('canvas')
      canvas.width = pageWidth
      //console.log('PDFCanvasGenerator',pageWidth,canvas.width)
      let ctx = canvas.getContext('2d')
      
      //var canvas = document.getElementById('canvas');
      if (canvas.getContext) {
        //var ctx = canvas.getContext('2d');

        //ctx.save();
        
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(262,0.5);
        ctx.lineTo(262,0.5);
        ctx.lineTo(221,0.5);
        ctx.lineTo(0,0.5);
        ctx.lineTo(0,99.5);
        ctx.lineTo(221,99.5);
        ctx.lineTo(262,99.5);
        ctx.lineTo(262,99.5);
        ctx.lineTo(311.5,50);
        ctx.lineTo(262,0.5);
//         ctx.shadowColor = 'black';
// ctx.shadowBlur = 5;
// ctx.shadowOffsetX = 0;
// ctx.shadowOffsetY = 3;
        ctx.fillStyle = "#23A6D5";
        ctx.strokeStyle = "#ffffff";
        //ctx.lineWidth = 16;

        ctx.fill();

        ctx.closePath();
        ctx.stroke();
        ctx.restore();
        

        //ctx.restore();
        document.body.appendChild(canvas)
        //console.log(canvas.offsetWidth,canvas.offsetLeft,canvas.width,canvas.offsetHeight,canvas.offsetTop,canvas.height)
        let canvaswidth = canvas.width
        let canvasheight = canvas.height
        doc.setFillColor(255,255,255)
        var fullQuality = canvas.toDataURL('image/png', 1.0);
        var mediumQuality = canvas.toDataURL('image/png', 0.5);
        var lowQuality = canvas.toDataURL('image/png', 0.1);

        doc.addImage(fullQuality, 'PNG', widthposition, heightposition, canvaswidth, canvasheight);
       
        elmnt.HeightPositionStart = heightposition
        elmnt.HeightPositionEnd = heightposition+canvasheight
        elmnt.WidthPositionStart = widthposition
        elmnt.WidthPositionEnd = widthposition+canvaswidth
        elmnt.PreviewHeightPosition = elmnt.HeightPositionStart*vm.DocumentDisplayRatio
        elmnt.PreviewWidthPosition = elmnt.WidthPositionStart*vm.DocumentDisplayRatio
        elmnt.Output = canvas
        resolve(elmnt)
      }

      // if second path like header banner 
      //ctx.beginPath()
      // ctx.fillRect(125, 35, 50, 50)
      
      
      // let dataUrl = vm.SVGToImage(_settings)
      
      })
      
    },
//     SVGToImage(settings){
//     let _settings = {
//         svg: null,
//         // Usually all SVG have transparency, so PNG is the way to go by default
//         mimetype: "image/png",
//         quality: 0.92,
//         width: "auto",
//         height: "auto",
//         outputFormat: "base64"
//     };

//     // Override default settings
//     for (let key in settings) { _settings[key] = settings[key]; }

//     return new Promise(function(resolve, reject){
//         let svgNode;

//         // Create SVG Node if a plain string has been provided
//         if(typeof(_settings.svg) == "string"){
//             // Create a non-visible node to render the SVG string
//             let SVGContainer = document.createElement("div");
//             SVGContainer.style.display = "none";
//             SVGContainer.innerHTML = _settings.svg;
//             svgNode = SVGContainer.firstElementChild;
//         }else{
//             svgNode = _settings.svg;
//         }

//         let canvas = document.createElement('canvas');
//         let context = canvas.getContext('2d'); 

//         let svgXml = new XMLSerializer().serializeToString(svgNode);
//         let svgBase64 = "data:image/svg+xml;base64," + btoa(svgXml);

//         const image = new Image();

//         image.onload = function(){
//             let finalWidth, finalHeight;

//             // Calculate width if set to auto and the height is specified (to preserve aspect ratio)
//             if(_settings.width === "auto" && _settings.height !== "auto"){
//                 finalWidth = (this.width / this.height) * _settings.height;
//             // Use image original width
//             }else if(_settings.width === "auto"){
//                 finalWidth = this.naturalWidth;
//             // Use custom width
//             }else{
//                 finalWidth = _settings.width;
//             }

//             // Calculate height if set to auto and the width is specified (to preserve aspect ratio)
//             if(_settings.height === "auto" && _settings.width !== "auto"){
//                 finalHeight = (this.height / this.width) * _settings.width;
//             // Use image original height
//             }else if(_settings.height === "auto"){
//                 finalHeight = this.naturalHeight;
//             // Use custom height
//             }else{
//                 finalHeight = _settings.height;
//             }

//             // Define the canvas intrinsic size
//             canvas.width = finalWidth;
//             canvas.height = finalHeight;

//             // Render image in the canvas
//             context.drawImage(this, 0, 0, finalWidth, finalHeight);

//             if(_settings.outputFormat == "blob"){
//                 // Fullfil and Return the Blob image
//                 canvas.toBlob(function(blob){
//                     resolve(blob);
//                 }, _settings.mimetype, _settings.quality);
//             }else{
//                 // Fullfil and Return the Base64 image
//                 resolve(canvas.toDataURL(_settings.mimetype, _settings.quality));
//             }
//         };

//         // Load the SVG in Base64 to the image
//         image.src = svgBase64;
//     });
// },
    PDFRectangleGenerator(pagenumber,page,doc,pageWidth,pageHeight,topposition,elmnt,colstart){
      
      let vm = this
      return new Promise(function(resolve, reject) {
      //alert('oh yeah a rectangle on '+page.PageNumber)
      //if not "beneathSucceeding, then add to page.LastContentHeightPositionEnd"
      //console.log(elmnt,colstart,pageWidth)
      //console.log(topposition,elmnt.PaddingTop)
      if(elmnt.DrawColor){
        //alert('draw color '+elmnt.DrawColor.r+' '+elmnt.DrawColor.g+' '+elmnt.DrawColor.b)
        doc.setDrawColor(elmnt.DrawColor.r, elmnt.DrawColor.g, elmnt.DrawColor.b)  
      }
      if(elmnt.FillColor){     
        //console.log('elmnt.FillColor ',elmnt.Name,elmnt.FillColor)                  
        doc.setFillColor(elmnt.FillColor.r, elmnt.FillColor.g, elmnt.FillColor.b);  
      }
      let rectangletopposition = topposition+elmnt.PaddingTop
      let rectanglewidth = elmnt.RectangleWidth
      let rectangleheight = elmnt.RectangleHeight
      if(elmnt.RectangleisFullHeight){
        rectangleheight = pageHeight
      }
      let justify = elmnt.Justify
      let rectangleleftposition = colstart
      //console.log(colstart)
      if(justify === 'center'){
        rectangleleftposition = rectangleleftposition+(pageWidth/2)-(rectanglewidth/2)+elmnt.PaddingLeft
      }
      else if(justify === 'start'){
        rectangleleftposition = rectangleleftposition+elmnt.PaddingLeft
      }
      else if(justify === 'end'){
        rectangleleftposition = rectangleleftposition+pageWidth-rectanglewidth+elmnt.PaddingLeft
      }
      //console.log(rectangleleftposition, rectangletopposition, rectanglewidth, rectangleheight)
      doc.setPage(elmnt.pagenumber)
      doc.rect(rectangleleftposition, rectangletopposition, rectanglewidth, rectangleheight, elmnt.RectangleType)
      
        elmnt.HeightPositionStart = rectangletopposition
        elmnt.HeightPositionEnd = rectangletopposition+rectangleheight
        elmnt.WidthPositionStart = rectangleleftposition
        elmnt.WidthPositionEnd = rectangleleftposition+rectanglewidth
        elmnt.PreviewHeightPosition = elmnt.HeightPositionStart*vm.DocumentDisplayRatio
        elmnt.PreviewWidthPosition = elmnt.WidthPositionStart*vm.DocumentDisplayRatio
        let c = document.createElement('canvas')
        c.height = rectangleheight
        c.width = rectanglewidth
        var ctx = c.getContext("2d");
        ctx.fillStyle = "rgb("+elmnt.FillColor.r+","+elmnt.FillColor.g+","+elmnt.FillColor.b+")";
        ctx.fillRect(0, 0, rectanglewidth, rectangleheight);
        c.toBlob(function(blob) {
            //console.log('blob',blob)
        // console.log('toBlob',blob)       
        let url = URL.createObjectURL(blob);
        elmnt.Output = `<img height="`+rectangleheight*vm.DocumentDisplayRatio+`px;" width="`+rectanglewidth*vm.DocumentDisplayRatio+`px;" src="`+url+`"/>`
        resolve(elmnt)
        })
      })
    },
    PDFImageGenerator(pagenumber,fullobj,page,doc,pageWidth,pageHeight,totalpages,topposition,elmnt,colwidth,colstart,colend){
      
      let vm = this
      return new Promise(function(resolve, reject) {
      let path = ''
      if(elmnt.DataField){
       if(fullobj[elmnt.DataField.Name] && fullobj[elmnt.DataField.Name].url){
          path = fullobj[elmnt.DataField.Name].url
        }
        else if(fullobj.PDFExportSample){
          path = require('@/assets/ImageHolder.png')
        }
        else{
          path = fullobj[elmnt.DataField.Name]
        } 
      }
      else if(elmnt.DataSource === 'App Logo'){
        path = require('@/assets/invoicelogo.png')
      }
      
      const img = document.createElement('img')
      if(elmnt.DataSource === 'App Logo'){
      //img.height = 100
      // img.width = 256
      //img.style.objectFit = 'scale-down'
      //  img.width = 100
       //img.width = 350

      }
      
      img.crossOrigin = 'Anonymous'
      img.onload = function(event){
        //console.log('loading img')
        const dataUrl = vm.getDataUrl(event.currentTarget)
            //console.log('lineitempage',lineitempage)
            doc.setPage(elmnt.pagenumber)
            
            //console.log(pageHeight)
            //console.log(colwidth)
            let orientation = 'portrait'
            if(img.width > img.height){
              orientation = 'landscape'
            }
            const widthRatio = img.width > colwidth ? colwidth / img.width : img.width / colwidth
            const heightRatio = img.height > pageHeight ? pageHeight / img.height : img.height / pageHeight
            //console.log(widthRatio,heightRatio)
            let ratio = 1
            if(orientation === 'portrait'){
              ratio = widthRatio > heightRatio ? widthRatio : heightRatio;
            }
            else{
              ratio = widthRatio
            }
            const canvasWidth = img.width * ratio;
            const canvasHeight = img.height * ratio;
            //console.log(img.width,img.height)
            //console.log(ratio,canvasWidth)
            let heightposition = topposition+elmnt.PaddingTop
            let startwidthposition = ((colwidth/2)-(canvasWidth/2))+elmnt.PaddingLeft
            doc.addImage(dataUrl, 'JPEG', startwidthposition, heightposition, canvasWidth, canvasHeight);
            elmnt.HeightPositionStart = heightposition
            elmnt.HeightPositionEnd = heightposition+canvasHeight
            elmnt.WidthPositionStart = startwidthposition
            elmnt.WidthPositionEnd = startwidthposition+canvasWidth
            elmnt.PreviewHeightPosition = elmnt.HeightPositionStart*vm.DocumentDisplayRatio
            elmnt.PreviewWidthPosition = elmnt.WidthPositionStart*vm.DocumentDisplayRatio
            //console.log(canvasWidth)
            elmnt.Output = `<img  width="`+canvasWidth+`" height="`+canvasHeight+`" src="`+path+`"/>`
                    //console.log('img',img,startwidthposition, heightposition, canvasWidth, canvasHeight)   
                    resolve(elmnt)  
        // code here to use the dimensions
      }
      img.src = path
      //fullobj[elmnt.DataField]
      
      //console.log('img',img)
      })
    },
    ReturnHTMLValue(value,newelmnt,colwidth){
        newelmnt.style.width = colwidth+"px";
        newelmnt.style.whiteSpace = 'pre-line'
        //console.log(newelmnt)
        newelmnt.innerHTML = value
        document.body.appendChild(newelmnt)
        let result = newelmnt.innerText
        document.body.removeChild(newelmnt)
        // newelmnt.onload(event => {
        //   console.log(event,newelemnt.innerText)
        // })
        
        return result 
    },
    PDFTextGenerator(pagenumber,fullobj,page,doc,pageWidth,pageHeight,totalpages,topposition,elmnt,colwidth,colstart){
      //console.log('Field Details', elmnt.DataField,fullobj)
      let vm = this
      return new Promise(function(resolve, reject) {
      //console.log(fullobj,elmnt)
        let colend = colstart+colwidth
        
        let pagemax = doc.internal.pageSize.getWidth()-page.PagePaddingRight
        //console.log('pagenumber' +pagenumber,page.PagePaddingRight,colend,pagemax,elmnt,topposition)
      let newelmnt = document.createElement('div')
      if(elmnt.DataSource === 'Image'){
        resolve(vm.PDFImageGenerator(pagenumber,fullobj,page,doc,pageWidth,pageHeight,totalpages,topposition,elmnt,colwidth,colstart,colend))
      }
      else{
        let textvalue = ''
      //console.log(elmnt.DataField.Type,fullobj,elmnt)
      if(elmnt.DataSource === 'Custom Text'){
        if(!elmnt.RawHTML){
         textvalue = vm.ReturnHTMLValue(elmnt.TextValue,newelmnt,colwidth) 
        }
        else{
          textvalue = elmnt.TextValue          
        }
        //console.log(textvalue)
      }
      else if(elmnt.DataSource === 'User Value'){
        //console.log('vm.userLoggedIn',vm.userLoggedIn)
        textvalue = vm.userLoggedIn[elmnt.DataField.Name]
        //maybe it must consider this??
        // if(elmnt.DataLookupFieldType === 'Lookup'){
        //     textvalue = fullobj[elmnt.DataField.Name][elmnt.DataLookupFieldName.Name][elmnt.DataLookupFieldName.LookupFieldName]
        //     }
      }
      else if(elmnt.DataSource === 'Data Text'){
        //console.log('for textvalue',elmnt.Name,elmnt.DataField.Type,fullobj,elmnt.DataField)
        if(elmnt.DataField.Type === 'Lookup'){
          if(fullobj[elmnt.DataField.Name]){
            if(elmnt.DataLookupFieldType === 'Lookup'){
            textvalue = fullobj[elmnt.DataField.Name][elmnt.DataLookupFieldName.Name][elmnt.DataLookupFieldName.LookupFieldName]
            }
            else if(elmnt.DataLookupFieldType === 'Option Set'){
              textvalue = fullobj[elmnt.DataField.Name].Name
            }
            else if(elmnt.DataLookupFieldType === 'Common Field' && elmnt.DataLookupFieldCommonFieldType === 'Physical Address'){
            }
            else if(elmnt.DataLookupFieldType === 'Common Field' && elmnt.DataLookupFieldCommonFieldType === 'Postal Address'){
            }
            else if(elmnt.DataLookupFieldType === 'HTML' || elmnt.DataField.Type === 'Multiple Lines Text'){
              if(fullobj.PDFExportSample){
                textvalue = `Lorem ipsum dolor sit amet, no nam oblique veritus. Commune scaevola imperdiet`
              }
              else{
                textvalue = vm.ReturnHTMLValue(fullobj[elmnt.DataField.Name][elmnt.DataLookupFieldName.Name],newelmnt,colwidth)
              }              
            }
            else{
              textvalue = fullobj[elmnt.DataField.Name][elmnt.DataLookupFieldName.Name]
            }
          }
          else{
            textvalue = 'No '+elmnt.DataField.Name+' Field Value'
             if(elmnt.DataLookupFieldType === 'Number Field' && elmnt.DataField.IsCurrency){
               //not too sure abot this one, what value would be "isCurrency" exactly?
                textvalue = vm.CurrencyFormatter(textvalue,vm.$store.state.DefaultCurrency.Currency)
              }
          }
                   
        }
        else if(elmnt.DataField.Type === 'Option Set'){
          textvalue = fullobj[elmnt.DataField.Name].Name
        }
        else if(elmnt.DataField.Type === 'Common Field' && elmnt.DataField.CommonFieldType === 'Physical Address' || elmnt.DataField.Type === 'Common Field' && elmnt.DataField.CommonFieldType === 'Postal Address'){
         
          if(elmnt.DataField.FieldBreakdown){
            let pass = true
            elmnt.DataField.FieldBreakdown.map((brd,brdindex) => {
                textvalue = textvalue+``+fullobj[brd.Name]
                if(!fullobj[brd.Name]){
                  pass = false
                }
                if(brdindex-1+2 !== elmnt.DataField.FieldBreakdown.length && brdindex !== 0){
                  textvalue = textvalue+`, `
                }
                else if(brdindex === 0){
                  textvalue = textvalue+` `
                }
                if(brdindex === 2 || brdindex === 4){
                  textvalue = textvalue+`<br>`
                }
                //console.log(textvalue)
                if(brdindex-1+2 === elmnt.DataField.FieldBreakdown.length && pass){
                  textvalue = vm.ReturnHTMLValue(textvalue,newelmnt,colwidth)
                }
                else if(!pass){
                  textvalue = ''
                }
            })
          }          
        }
        else if(elmnt.DataField.Type === 'Date'){
          
          textvalue = fullobj[elmnt.DataField.Name]
          console.log(elmnt.DataField,fullobj,textvalue)
          if(textvalue.toDate){
            textvalue = textvalue.toDate()            
          }
          textvalue = new Date(textvalue)
          if(!elmnt.DataField.HasTimeInput){
            
            textvalue = textvalue.toDateString()
          }
        }
        else if(elmnt.DataField.Type === 'HTML' || elmnt.DataField.Type === 'Multiple Lines Text'){
           if(fullobj.PDFExportSample){
                textvalue = `Lorem ipsum dolor sit amet, no nam oblique veritus. Commune scaevola imperdiet`
              }
              else{
                textvalue = vm.ReturnHTMLValue(fullobj[elmnt.DataField.Name],newelmnt,colwidth)
              } 
          }
        else{
          //console.log('for textvalue',fullobj,elmnt.DataField)
          textvalue = fullobj[elmnt.DataField.Name]
          if(elmnt.DataField.Type === 'Number Field' && elmnt.DataField.IsCurrency){
            textvalue = vm.CurrencyFormatter(textvalue,vm.$store.state.DefaultCurrency.Currency)
          }
        }
      }
      else if(elmnt.OutputType === 'Boolean Response'){
        if(fullobj[elmnt.DataField] && elmnt.BooleanTrueResponse){
          textvalue = vm.ReturnHTMLValue(elmnt.BooleanTrueResponse,newelmnt,colwidth)
        }
        else if(!fullobj[elmnt.DataField] && elmnt.BooleanFalseResponse){
          textvalue = vm.ReturnHTMLValue(elmnt.BooleanFalseResponse,newelmnt,colwidth)
        }
      }
        doc.setTextColor(elmnt.FontColor.r, elmnt.FontColor.g, elmnt.FontColor.b);
        doc.setFontSize(elmnt.FontSize);
        doc.setFont(undefined, elmnt.FontStyle)
        let splittowdith = colwidth-elmnt.PaddingLeft
        //console.log(splittowdith)
        var splitTitle = doc.splitTextToSize(textvalue, splittowdith);
        let textlength = splitTitle[0].length
        let elmntleftposition = colstart
        let textwidth = doc.getTextDimensions(splitTitle)
        if(elmnt.Justify === 'center'){
          elmntleftposition = colstart+((colwidth-textwidth.w)/2)+elmnt.PaddingLeft
        }
        else if(elmnt.Justify === 'start'){
          elmntleftposition = colstart+elmnt.PaddingLeft
        }
        else if(elmnt.Justify === 'end'){
          elmntleftposition = colend-(textlength*(elmnt.FontSize/2))
        }
        if(elmnt.OutputType === 'HTML'){          
              doc.setPage(elmnt.pagenumber)
            if(elmntleftposition+textwidth.w>pagemax){
                //console.log('oops here one on pagenumber '+pagenumber,elmnt)
                splittowdith = splittowdith-(elmntleftposition+textwidth.w-pagemax)
                splitTitle = doc.splitTextToSize(textvalue, splittowdith)
            }
            //console.log(elmntleftposition,topposition,elmnt.PaddingTop,splitTitle,topposition+elmnt.PaddingTop)
            if(!elmnt.RawHTML){
             doc.text(elmntleftposition,topposition+elmnt.PaddingTop,splitTitle) 
            }
            else{
              let font = doc.getFont() 
              let rawhtml = document.createElement('div')
              rawhtml.innerHTML = textvalue
              rawhtml.setAttribute('style','font-size:12px !important;font-family: '+font.fontName+';color: rgb(89,89,89) !important;')
              //rawhtml.setAttribute('style','font-color: rgb(89,89,89) !important;')
              document.body.appendChild(rawhtml)        
                  //console.log(rawhtml,rawhtml.clientHeight,rawhtml.clientWidth)
                  let startwidthposition = 0
                  if(elmnt.Justify === 'center'){
                    
                    startwidthposition = (pageWidth-elmnt.ElementWidth)/2
                    elmntleftposition = startwidthposition
                    //console.log(pageWidth)
                  }
                  doc.html(rawhtml, {
                    callback: function(doc) {
                     resolve(elmnt)
                     document.body.removeChild(rawhtml)
                    },
                    x: startwidthposition,
                    y: topposition+elmnt.PaddingTop
                  });
              //}
            }
            
            //document.body.removeChild(newelmnt)
      }
      else{
        if(elmntleftposition+textwidth.w>doc.internal.pageSize.getWidth()){
          splittowdith = splittowdith-(elmntleftposition+textwidth.w-pagemax)
          splitTitle = doc.splitTextToSize(textvalue, splittowdith)
          //console.log('oops here one on pagenumber '+pagenumber,elmnt,splitTitle,splittowdith,colwidth,elmnt.PaddingLeft,elmntleftposition,textwidth.w,pagemax)
        }
        //console.log(elmntleftposition,topposition+elmnt.PaddingTop,splitTitle)
        doc.setPage(elmnt.pagenumber)
        doc.text(elmntleftposition,topposition+elmnt.PaddingTop,splitTitle)
      }      
        elmnt.HeightPositionStart = topposition+elmnt.PaddingTop
        elmnt.HeightPositionEnd = topposition+elmnt.PaddingTop+textwidth.h
        elmnt.WidthPositionStart = elmntleftposition
        elmnt.WidthPositionEnd = elmntleftposition+textwidth.w
        // elmnt.TotalWidth = textwidth.w
        // console.log(textwidth.w)
        elmnt.PreviewHeightPosition = (elmnt.HeightPositionStart-elmnt.FontSize)*vm.DocumentDisplayRatio
        elmnt.PreviewWidthPosition = elmnt.WidthPositionStart*vm.DocumentDisplayRatio
        if(elmnt.Justify === 'center'){
            elmnt.PreviewWidthPosition = ((pageWidth*vm.DocumentDisplayRatio)-elmnt.ElementWidth)/2        
           
          }
        let outputfontcolor = 'color:rgb('+elmnt.FontColor.r+', '+elmnt.FontColor.g+', '+elmnt.FontColor.b+');'
        // elmnt.FontColor.r, elmnt.FontColor.g, elmnt.FontColor.b
        let htmlprop = 'p'
        if(elmnt.FontStyle === 'bold'){
            htmlprop = 'b'
        }
        //console.log(elmnt)
        //alert(vm.DocumentDisplayRatio)
        elmnt.Output = `<`+htmlprop+` style="font-size:`+elmnt.FontSize*vm.DocumentDisplayRatio*0.9+`px;`+outputfontcolor+`">`+textvalue+`</`+htmlprop+`>`
        if(!elmnt.RawHTML){
          resolve(elmnt)
        }
      }
      })
    },
    CurrencyFormatter(value,currency){
        const currencyformatter = this.PrepareCurrency(currency)
        let formalformat = currencyformatter.format(value)
        return formalformat
        },
        PrepareCurrency(currency){			
        let currobj = this.$store.state.Currencies.find(obj => obj.Currency === currency)
        let lang = this.$store.state.DefaultCurrency.LangForm
        if(currobj){
            lang = currobj.LangForm
        }
        return new Intl.NumberFormat(lang, {			
                style: 'currency',			
                currency: currency,			
                minimumFractionDigits: 2			
            })
        
        },
    BasePDFTextGenerator(doc,TextObj){
      if(TextObj.DataSource === 'Custom Text'){
        doc.setTextColor(TextObj.FontColor.r, TextObj.FontColor.g, TextObj.FontColor.b);
        doc.setFontSize(TextObj.FontSize);
        doc.text(TextObj.LeftPosition,TextObj.TopPosition,TextObj.TextValue)
      }
    },
    PrepExportPDFBoxedText(elmnt,doc,rectangletopposition,rectanglewidth,rectangleheight,justify,pageWidth,pageHeight,TextObj,FillColor,DrawColor){      
      if(DrawColor){
        doc.setDrawColor(DrawColor.r, DrawColor.g, DrawColor.b)  
      }
      if(FillColor){                       
        doc.setFillColor(FillColor.r, FillColor.g, FillColor.b);  
      }
      let rectangleleftposition = 0
      if(justify === 'center'){
        rectangleleftposition = (pageWidth/2)-(rectanglewidth/2)
      }
      else if(justify === 'start'){
        rectangleleftposition = 0
      }
      else if(justify === 'end'){
        rectangleleftposition = pageWidth-rectanglewidth
      }      
      doc.rect(rectangleleftposition, rectangletopposition, rectanglewidth, rectangleheight, 'FD')
      TextObj.LeftPosition = TextObj.PaddingLeft+rectangleleftposition      
      TextObj.TopPosition = TextObj.PaddingTop+rectangletopposition+(TextObj.FontSize/2)
      //console.log(TextObj.TopPosition,rectangletopposition)
      this.BasePDFTextGenerator(doc,TextObj)
    },
    PreparePDFPage(elmnt,pagenumber,fullobj,page,doc,pageWidth,pageHeight,totalpages,fromwatermark){
      
                          elmnt.HeightPositionStart = 0
                          elmnt.HeightPositionEnd = 0
                          elmnt.WidthPositionStart = 0
                          elmnt.WidthPositionEnd = 0
                          
                          if(elmnt.DrawColor && elmnt.DrawColor.rgba){
                              elmnt.DrawColor.r = elmnt.DrawColor.rgba.r
                              elmnt.DrawColor.g = elmnt.DrawColor.rgba.g
                              elmnt.DrawColor.b = elmnt.DrawColor.rgba.b
                          }
                          if(elmnt.FillColor && elmnt.FillColor.rgba){
                              elmnt.FillColor.r = elmnt.FillColor.rgba.r
                              elmnt.FillColor.g = elmnt.FillColor.rgba.g
                              elmnt.FillColor.b = elmnt.FillColor.rgba.b
                          }
                          if(elmnt.FontColor && elmnt.FontColor.rgba){
                              elmnt.FontColor.r = elmnt.FontColor.rgba.r
                              elmnt.FontColor.g = elmnt.FontColor.rgba.g
                              elmnt.FontColor.b = elmnt.FontColor.rgba.b
                          }
                          elmnt.PreviewHeightPosition = 0
                          elmnt.PreviewWidthPosition = 0
      let vm = this
      return new Promise(function(resolve, reject) { 
      //console.log('pagenumber'+page.PageNumber+' details (should be post watermark)')
            let width = pageWidth
            let widthposition = 0
            let topposition = 0
            //console.log('pagenumber '+page.PageNumber,page.LastContentHeightPositionStart,page.LastContentHeightPositionEnd,page.LastContentWidthPositionStart,page.LastContentWidthPositionEnd)
              if(elmnt.InheritTopPosition){
                let inheritparent = page.Elements.find(obj => obj.ElementID === elmnt.InheritedTopPositionParent.ElementID)               
                if(elmnt.InheritedTopPosition === 'Start'){
                  topposition = inheritparent.HeightPositionStart
                }
                else if(elmnt.InheritedTopPosition === 'End'){
                  //alert(elmnt.Name+' parent height positionend '+inheritparent.HeightPositionEnd)
                  //position end points to how we need to start fulfilling promise on each item in the array before computing the next item in the array. In fact it poitns to how this entire export function may be computed property
                  //on current sample the height position end is 467, but oat this point the child gets the initial inherit position which is 340. So on render and export image overlaps text that should precede it
                  if(inheritparent && inheritparent.OutputType === 'Image'){
                      topposition = inheritparent.HeightPositionEnd
                  }
                  else if(inheritparent){
                    topposition = inheritparent.HeightPositionEnd
                  }                  
                  //console.log(elmnt.Name,topposition,inheritparent,elmnt,inheritparent.HeightPositionEnd)
                }  
                              
              }
              if(elmnt.InheritWidthPosition){
                let inheritparent = page.Elements.find(obj => obj.ElementID === elmnt.InheritedWidthPositionParent.ElementID)               
                if(inheritparent && elmnt.InheritedWidthPosition === 'Start'){
                  widthposition = inheritparent.WidthPositionStart
                }
                else if(inheritparent && elmnt.InheritedWidthPosition === 'End'){
                  widthposition = inheritparent.WidthPositionEnd  
                }
                //console.log(elmnt.Name,widthposition,inheritparent)               
              }
              if(elmnt.WidthOption === 'Half Page'){
                  //width = (width/2)-widthposition
                  width = width/2
                  if(widthposition < width){
                    //width = width-widthposition
                  }
              }
              else if(elmnt.WidthOption === 'Third Page'){
                  //width = (width/3)-widthposition
                  width = width/3
                  if(widthposition < width){
                   // width = width-widthposition
                  }
              }
              if(elmnt.OutputType === 'Rectangle'){
                resolve(vm.PDFRectangleGenerator(pagenumber,page,doc,width,pageHeight,topposition,elmnt,widthposition))
              }
              else if(elmnt.OutputType === 'Text' || elmnt.OutputType === 'HTML' || elmnt.OutputType === 'Boolean Response'){
                resolve(vm.PDFTextGenerator(pagenumber,fullobj,page,doc,width,pageHeight,totalpages,topposition,elmnt,width,widthposition))
              }
              else if(elmnt.OutputType === 'Image'){
                resolve(vm.PDFImageGenerator(pagenumber,fullobj,page,doc,width,pageHeight,totalpages,topposition,elmnt,width,widthposition))
              }
              else if(elmnt.OutputType === 'Canvas'){              
                resolve(vm.PDFCanvasGenerator(pagenumber,fullobj,page,doc,width,pageHeight,totalpages,topposition,elmnt,width,widthposition))
              }
              else if(elmnt.OutputType === 'Line'){
                resolve(vm.PDFLineGenerator(pagenumber,fullobj,page,doc,width,pageHeight,totalpages,topposition,elmnt,width,widthposition))
              }
      })
    },
    
    ExporttoPDF2(){
      var pdf = new jsPDF("p", "pt", "a4");
  pdf.setFontSize("10");
  pdf.setLineWidth("100");
  pdf.setTextColor("darkblue");

  // Printing text
  var vuejsinformation = `JQuery is a lightweight, "write less, do more", JavaScript library.`;
  pdf.text(vuejsinformation, 10, 10);
      pdf.html(document.getElementById("webordertest"), {
        callback: function (pdf) {
          pdf.save("Sample.pdf");
        },
        x: 10,
        y: 10,
      });
    },
    CreateExportTemplate(){
        let ref = db.collection('Databases').doc(this.$store.state.ActiveSuiteid).collection('pdfexportfunctions').doc()
        let newdocid = ref.id
        this.$router.push('/PDFExportFunctionBuilder/'+newdocid)
    },
    

    ExporttoPDF(pdffunction){
            let vm = this            
            const doc = new jsPDF(pdffunction.FunctionOutput.orientation, pdffunction.FunctionOutput.unit, pdffunction.FunctionOutput.format);
            this.doc = doc
            let pagescount = this.FunctionExportPages.length
            for(var x = 1;x < pagescount;x++){
              doc.addPage()
            }
            
            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();
            //console.log(pageWidth,pageHeight)
            console.log(this.FunctionExportPages)
             let length = this.FunctionExportPages.length
                this.FunctionExportPages
                .reduce( async (previouspagePromise, page,pageindex) => {
                  await previouspagePromise;
                  return vm.InitiatePDFPage(page,doc,pageWidth,pageHeight,pagescount).then(result => {
                    console.log('previouspagePromise',previouspagePromise,result)
                    if(result){                      
                      if(length === pageindex-1+2){
                        if(vm.$route.name !== 'PDFExportFunctionBuilder' && !vm.RecordasPDF){
                          if(vm.PushCompletedFile){
                           vm.$emit('DeactivateExportingtoPDFDialog',doc) 
                           vm.Refreshed = true
                          }
                          else{
                            vm.$emit('DeactivateExportingtoPDFDialog')
                            doc.save(vm.FullItem[vm.FullItem.RecordPrimaryFieldName]+" - "+vm.SelectedFunction.FunctionDisplayName+".pdf")
                          }
                          
                        }
                        else{
                          vm.Refreshed = true
                        }
                      }
                    }
                  });
                  }, Promise.resolve());             
           
    },
    InitiatePDFPage(page,doc,pageWidth,pageHeight,pagescount){
      let vm = this
      return new Promise(function(resolve, reject) { 
      if(page.PageHasWaterMark){
         return vm.PreparePageWatermark(page,doc,pageWidth,pageHeight,pagescount).then(result => {
              if(result){
                resolve(page)
              }
         })
        }
        else{                  
          let length = page.Elements.length
          page.Elements.reduce( async (previousPromise, elmnt,elmntindex) => {
            await previousPromise;
            let fullobj = ''
            if(page.PageDatafromArray){
              fullobj = elmnt.fullobj
            }
            else{
              fullobj = vm.FullItem
            }
                
            return vm.PreparePDFPage(elmnt,page.PageNumber,fullobj,page,doc,pageWidth,pageHeight,pagescount).then(result => {
              if(result){
                if(elmntindex-1+2 === length){
                    if(vm.$route.name !== 'PDFExportFunctionBuilder' && !vm.RecordasPDF){
                      resolve(page)
                          // doc.save(vm.FullItem[vm.FullItem.RecordPrimaryFieldName]+" - "+vm.SelectedFunction.FunctionDisplayName+".pdf") 
                        }
                        else{
                          resolve(page)
                          // vm.Refreshed = true
                        }
                  }
              }
            });
          }, Promise.resolve()); 
        }
      })
    },
    PreparePageWatermark(page,doc,pageWidth,pageHeight,totalpages,fullobj){
      let vm = this
      //console.log('pagenumber'+page.PageNumber+' watermark in progress')
      return new Promise(function(resolve, reject) { 
      const watermarkimg = document.createElement('img')
                    watermarkimg.crossOrigin = 'Anonymous'
                    //watermarkimg.src = require('@/assets/'+page.PageWaterMarkObject.FullName)
                    watermarkimg.src = page.PageWaterMarkObject.Path
                    watermarkimg.addEventListener('load', function (event) {
                    const dataUrl = vm.getDataUrl(event.currentTarget)
                    let pagenumber = 0
                    const widthRatio = watermarkimg.width > pageWidth ? pageWidth / watermarkimg.width : watermarkimg.width / pageWidth
                    const heightRatio = watermarkimg.height > pageHeight ? pageHeight / watermarkimg.height : watermarkimg.height / pageHeight
                    //const ratio = widthRatio > heightRatio ? widthRatio : heightRatio;
                    //Okay so if we have a portrait image on a landscape pdf, this adjusts the image to fulheigh, leaving width space open
                    //Although if we set to widthratio always then landcape image in landscape actually sucks.
                    //So we need to know if this landscape or portrait function. then is it landscape or portraint pic
                    //now I think this formula already tells us given if widthratio is higher, uhm..yeah no that's ratio. you get?
                    //this needs thought
                    const ratio = widthRatio > heightRatio ? widthRatio : heightRatio;
                    const canvasWidth = watermarkimg.width * ratio;
                    const canvasHeight = watermarkimg.height * ratio;
                      pagenumber = page.PageNumber
                      doc.setPage(pagenumber)
                      doc.addImage(dataUrl, 'JPEG', 0, 0, canvasWidth, canvasHeight); 
                      //vm.PreparePDFPage(elmnt,pagenumber,fullobj,page,doc,pageWidth,pageHeight,totalpages)
                       //console.log('pagenumber'+page.PageNumber+' watermark in received')
                        let length = page.Elements.length
                        page.Elements.reduce( async (previousPromise, elmnt,elmntindex) => {
                          await previousPromise;
                          let fullobj = ''
                          if(page.PageDatafromArray){
                            fullobj = elmnt.fullobj
                          }
                          else{
                            fullobj = vm.FullItem
                          }
                              // if(elmntindex-1+2 === length){
                              //     if(vm.$route.name !== 'PDFExportFunctionBuilder'){
                              //           doc.save(vm.FullItem[vm.FullItem.RecordPrimaryFieldName]+" - "+vm.SelectedFunction.FunctionDisplayName+".pdf") 
                              //         }
                              //         else{
                              //           vm.Refreshed = true
                              //         }
                              //   }
                          return vm.PreparePDFPage(elmnt,pagenumber,fullobj,page,doc,pageWidth,pageHeight,totalpages,true).then(result => {
                            //console.log('result',result)
                            if(result && elmntindex-1+2 === length){
                              resolve(page)
                            }
                          });
                        }, Promise.resolve());                                      
                    });
                    
      })
    },
        
    }
}
</script>

<style>

</style>

    